import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 44C34.1502 44 44 34.1502 44 22C44 9.84981 34.1502 0 22 0C9.84981 0 0 9.84981 0 22C0 34.1502 9.84981 44 22 44ZM29.9812 8.9375C31.2366 8.9375 32.3125 9.97906 32.3125 11.3678V32.6322C32.3125 33.935 31.2366 35.0625 29.9812 35.0625H14.0181C13.3829 35.0168 12.7887 34.7314 12.356 34.2641C11.9232 33.7968 11.6843 33.1825 11.6875 32.5456V11.3678C11.6875 9.97906 12.7634 8.9375 14.0188 8.9375H29.9819H29.9812ZM21.6562 28.875C20.3088 28.875 19.25 29.7825 19.25 30.9375C19.25 32.0925 20.3088 33 21.6562 33C23.0037 33 24.0625 32.0925 24.0625 30.9375C24.0625 29.7825 23.0037 28.875 21.6562 28.875ZM28.1875 11.715H15.8125C15.0954 11.715 14.4671 12.3228 14.4671 13.0171V24.8208C14.4671 25.5152 15.0954 26.1229 15.8125 26.1229H28.1875V26.0356C28.9046 26.0356 29.5329 25.4286 29.5329 24.7342V13.0171C29.5329 12.3228 28.9046 11.715 28.1875 11.715ZM24.2412 14.1453C24.7796 14.1453 25.1384 14.4925 25.1384 15.0129C25.1384 15.5341 24.7796 15.8813 24.2419 15.8813H19.7581C19.2204 15.8813 18.8616 15.5341 18.8616 15.0129C18.8616 14.4925 19.2204 14.1453 19.7581 14.1453H24.2419H24.2412Z",
  fill: "#ffb500"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default render